// extracted by mini-css-extract-plugin
module.exports = {"root":"Add_root__d5cj0","plus":"Add_plus__1_QpD","over":"Add_over__1NHgs"};